<!-- 
  详情页 - 红冲合同 回款计划
  props:
    id: 详情id
 -->

<template>
  <div class="v-tabs product-list">
    <div class="head" v-if="totalNum">
      <div class="total">
        关联回款单：{{totalNum}} 笔
      </div>
      <div class="inline-item">
        退款总金额：<span class="red">{{totalAmount}}</span>
      </div>
    </div>
    <div class="content">
      <el-table
        v-if="approvalId"
        :data="tableData"
        border
        highlight-current-row
        style="width: 100%"
        @click.native="paymentDetail">
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column
          label="关联回款单"
          property="sheetNo"
          width="200"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          :label="'回款金额('+unit+')'">
          <template slot-scope="scope">
            <span class="red">{{scope.row.amount}}</span>
          </template>
        </el-table-column>
        <el-table-column
          property="paymentTime"
          label="回款日期">
        </el-table-column>
      </el-table>

      <el-table
        v-else
        :data="tableData"
        border
        highlight-current-row
        style="width: 100%"
        @click.native="paymentDetail">
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column
          property="paymentNo"
          label="关联回款计划"
          width="200"
          show-overflow-tooltip>
          <!-- 详情页 -->
          <template slot-scope="scope">
            <a
              data-type="detail"
              :data-id="scope.row.paymentId"
              :data-popmodel="'paymentApi'">
              {{scope.row.paymentNo}}
            </a>
          </template>
        </el-table-column>
        <el-table-column
          :label="'退款金额('+unit+')'"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="red">{{scope.row.amount}}</span>
          </template>
        </el-table-column>
        <el-table-column
          property="status"
          label="状态"
          width="80"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          property="paymentTime"
          label="退款日期"
          show-overflow-tooltip>
        </el-table-column>
      </el-table>
    </div>

  </div>
</template>

<script>
import * as api from 'src/api'
import { mapActions } from 'vuex'

export default {
  created () {
    this.getList()
  },
  props: {
    id: {
      type: Number,
      approvalId: Number
    },
    moduleName: {
      type: String,
      required: true
    },
    approvalId: Number
  },
  data () {
    return {
      tableData: [],
      totalAmount: 0, // 退款金额
      totalNum: 0, // 退款单数
      paymentShow: false,
      initData: {},
      unit: '元'
    }
  },
  methods: {
    ...mapActions([
      'setRedStatus'
    ]),
    paymentDetail (event) {
      // 获取目标元素或目标父元素的data属性集合
      let data = event.target.dataset
      let parent = event.target.parentNode.dataset
      if (data.type || parent.type && (data = parent)) {
        this.detailId = Number(data.id)
        // 设置当前的红冲状态
        this.setRedStatus(true)
        this.$emit('openDetail', 'paymentApi', this.detailId)
      }
    },
    getList () {
      let url = ''
      if (this.approvalId) {
        url = '/refund/getRefundPaymentSheets.html'
      } else {
        url = '/contractApi/getRedPayment.html'
      }
      let params = {
        id: this.id
      }
      api.post(url, params, (data) => {
        this.tableData = data.result
        this.totalAmount = data.totalAmount
        this.totalNum = data.totalNum
        this.unit = data.unit || '元'
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../../assets/less/variable.less';

  .product-list {
    .red {
      color: @bg-red;
    }
  }
</style>


// WEBPACK FOOTER //
// payment-list.vue?4ce9200b